import actions from './actions';
import Cookies from 'js-cookie';

const { changeLayoutBegin, changeLayoutSuccess, changeLayoutErr, } = actions;

const changeLayoutMode = (value) => {
  return async (dispatch) => {
    try {
      dispatch(changeLayoutBegin());
      dispatch(changeLayoutSuccess(value));
    } catch (err) {
      dispatch(changeLayoutErr(err));
    }
  };
};
export { changeLayoutMode };
